/*External dependencies */
import update from 'immutability-helper';

/* Local dependencies */
import { UpdateDeviceActions, UpdateDeviceActionTypes } from './action';

export interface UpdateDeviceState {
  isUpdateDeviceModalOpen: boolean;
  isUpdateLoading: boolean;
  organizationValue: string;
  notesValue: string;
  isDeviceUpdated: boolean;
  isDeviceUpdateFailed: boolean;
  error: string;
}

export const initialUpdateDeviceState: UpdateDeviceState = {
  isUpdateDeviceModalOpen: false,
  isUpdateLoading: false,
  organizationValue: '',
  notesValue: '',
  isDeviceUpdated: false,
  isDeviceUpdateFailed: false,
  error: '',
};
export function updateDeviceReducer(state = initialUpdateDeviceState, action: UpdateDeviceActions) {
  switch (action.type) {
    case UpdateDeviceActionTypes.OPEN_UPDATE_DEVICE_MODAL:
      return update(state, {
        isUpdateDeviceModalOpen: { $set: true },
        organizationValue: { $set: action.payload.organization },
        notesValue: { $set: action.payload.notes || '' },
      });
    case UpdateDeviceActionTypes.CLOSE_UPDATE_DEVICE_MODAL:
      return update(state, {
        isUpdateDeviceModalOpen: { $set: false },
        isDeviceUpdated: { $set: false },
        organizationValue: { $set: '' },
        notesValue: { $set: '' },
        isDeviceUpdateFailed: { $set: false },
        isUpdateLoading: { $set: false },
      });
    case UpdateDeviceActionTypes.UPDATE_DEVICE_REQUEST:
      return update(state, {
        isUpdateLoading: { $set: true },
      });
    case UpdateDeviceActionTypes.ORGANIZATION_UPDATE:
      return update(state, {
        organizationValue: { $set: action.changedOrganization },
      });
    case UpdateDeviceActionTypes.NOTES_UPDATE:
      return update(state, {
        notesValue: { $set: action.changedNotes },
      });
    case UpdateDeviceActionTypes.UPDATE_DEVICE_SUCCEEDED:
      return update(state, {
        isUpdateLoading: { $set: false },
        isDeviceUpdated: { $set: true },
      });
    case UpdateDeviceActionTypes.UPDATE_DEVICE_FAILED:
      return update(state, {
        isUpdateLoading: { $set: false },
        error: { $set: action.error },
        isDeviceUpdateFailed: { $set: true },
      });
    default:
      return state;
  }
}
